import React, { createContext } from 'react';
import { useSelector } from 'react-redux';
import { useParams, Link } from 'react-router-dom';

// components and helpers
import { DashboardContext } from '@acoer/ac-js-lib-charts';
import Filters from '../Workspace/Dashboard/Analytics/Filters/Filters';
import Dashboard from '../Workspace/Dashboard/Dashboard';
import { IWorkspaceContextProps } from '../../common/model/WorkspaceModels';

//mui
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Tooltip from '@mui/material/Tooltip';

export const WrapperContext = createContext<IWorkspaceContextProps>(undefined!);
const AuditWrapper: React.FC = () => {
    let { id } = useParams();
    const currentWorkspace = useSelector(
        (state: any) => state.workspace.currentWorkspace
    );

    const handleChange = () => {
        console.log('this is a placeholder');
    };

    return (
        <Grid container spacing={2}>
            <Grid
                item
                xs={12}
                style={{ display: 'flex', alignItems: 'center' }}
            >
                <Tooltip
                    title={
                        currentWorkspace &&
                        Object.keys(currentWorkspace).length === 0
                            ? 'Return Home'
                            : 'Return to Workspace'
                    }
                >
                    <IconButton
                        color={'primary'}
                        component={Link}
                        to={
                            currentWorkspace &&
                            Object.keys(currentWorkspace).length === 0
                                ? '/'
                                : `/workspace/${id}`
                        }
                    >
                        <ArrowBackIcon />
                    </IconButton>
                </Tooltip>
                <Typography variant={'h5'}>
                    {id
                        ? `${
                              currentWorkspace && currentWorkspace.name
                          } Activities`
                        : 'All Activities'}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <DashboardContext.Provider
                    value={{
                        type: 'activity',
                        area: id ? id : '-all-',
                        tabValue: 0,
                    }}
                >
                    <Grid item xs={12} sx={{ marginBottom: 2, flexGrow: 1 }}>
                        <Filters
                            area={id ? id : '-all-'}
                            type={'activity'}
                            filterType={'full'}
                            allowFilterTemplates={false}
                        />
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <WrapperContext.Provider
                                value={{
                                    currentWorkspace: null,
                                    handleChange,
                                }}
                            >
                                <Dashboard />
                            </WrapperContext.Provider>
                        </Grid>
                    </Grid>
                </DashboardContext.Provider>
            </Grid>
        </Grid>
    );
};

export default AuditWrapper;
